import { useAppState } from '@/context/appState';
import { useCallback, useEffect, useState } from 'react';

export default () => {
  const { products } = useAppState();

  useEffect(() => {
    if (products.error) {
      throw new Error(products.error.message);
    }
  }, [products.error]);

  return {};
};
